/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppStartPayload
 */
export interface AppStartPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: AppStartPayloadTypeEnum;
    /**
     * 
     */
    gitSha?: string | null;
    /**
     * 
     */
    version?: string | null;
    /**
     * 
     */
    hostname?: string | null;
    /**
     * 
     */
    config?: { [key: string]: any; } | null;
}


/**
 * @export
 */
export const AppStartPayloadTypeEnum = {
    AppStart: 'app_start',
} as const;
export type AppStartPayloadTypeEnum = typeof AppStartPayloadTypeEnum[keyof typeof AppStartPayloadTypeEnum];


/**
 * Check if a given object implements the AppStartPayload interface.
 */
export function instanceOfAppStartPayload(value: object): value is AppStartPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'app_start') return false;
    
    return true;
}

export function AppStartPayloadFromJSON(json: any): AppStartPayload {
    return AppStartPayloadFromJSONTyped(json, false);
}

export function AppStartPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppStartPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'gitSha': json['git_sha'] === undefined ? undefined : json['git_sha'] === null ? null : json['git_sha'],
        'version': json['version'] === undefined ? undefined : json['version'] === null ? null : json['version'],
        'hostname': json['hostname'] === undefined ? undefined : json['hostname'] === null ? null : json['hostname'],
        'config': json['config'] === undefined ? undefined : json['config'] === null ? null : json['config'],
    };
}

export function AppStartPayloadToJSON(json: any): AppStartPayload {
    return AppStartPayloadToJSONTyped(json, false);
}

export function AppStartPayloadToJSONTyped(value?: AppStartPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'git_sha': value['gitSha'],
        'version': value['version'],
        'hostname': value['hostname'],
        'config': value['config'],
    };
}

